window.dataLayer = window.dataLayer || [];
window.productArray = {};
window.showLog = false;

var GA4 = {
  view_item_list: function(responseObj,collectionsName){
    if(responseObj && collectionsName){
      var products = responseObj.response.products;
      if(window.showLog) console.log("==========view_item_list=======");
      var items = [];
      window.productArray = {};
      for (i=0; i < products.length; i++) {
        var item = {},
          product = products[i];
        item.name = product.title;
        item.id = product.uniqueId;
        item.price = product.price;
        item.brand = product.vendor;
        item.category = collectionsName;
        item.variant = product.variants[0].title;
        item.list = "Category";
        item.position = i+1+responseObj.response.start;
        items.push(item);
        productArray[product.uniqueId] = item;
      }
      dataLayer.push({
        'event': "view_item_list",
        'ecommerce': {
          'currencyCode': "AUD",
          'impressions': items
        }
      })
    }
  },
  view_item: function(product,collectionsName){
    if(product && collectionsName){
      if(window.showLog) console.log("==========view_item=======");
      dataLayer.push({
      'event': "view_item",
      'ecommerce': {
        'currencyCode': "AUD",
        'detail':{
          'products':[{
            'name': product.title,
            'id': product.id,
            'price': product.price/100,
            'brand': product.vendor,
            'category': collectionsName,
            'variant': product.variants[0].title
          }]
        }  
      }
      })
    }
  },
  add_to_cart: function(product){
    if(window.showLog) console.log('======add_to_Cart======');
    if(product){
      dataLayer.push({
      'event': "add_to_cart",
      'ecommerce': {
        'currencyCode': "AUD",
        'add':{
          'products':[{
            'name': product.product_title,
            'id': product.product_id,
            'price': product.price/100,
            'brand': product.vendor,
            'variant': product.variant_title,
            'quantity': product.quantity
          }]
        }  
      }
    });
    var _learnq = window._learnq || [];
    _learnq.push(["track", "Added to Cart",{
    $value: product.price/100,
    "Brand": product.vendor,
    "ProductName": product.product_title,
    "ProductPrice": product.price/100,
    "ProductID": product.product_id,
    "ProductImageURL": product.image,
    "ProductURL": window.location.origin + product.url,
    "PageURL": window.location.href
  }]);
    }
  },
  bundle_add_to_cart: function(product_handle,$qty){
    if(window.showLog) console.log('======bundle_add_to_cart1======');
    var $product = JSON.parse(localStorage.getItem(product_handle));
    console.log("$product added",$product);
    console.log(product_handle,$qty);
    if($product){
      console.log("$product added",$product);
      dataLayer.push({
      'event': "add_to_cart",
      'ecommerce': {
        'currencyCode': "AUD",
        'add':{
          'products':[{
            'name': $product.title,
            'id': $product.id,
            'price': $product.price/100,
            'brand': $product.vendor,
            'variant': $product.variants[0].title,
            'quantity': $qty
          }]
        }  
      }
    });
      var _learnq = window._learnq || [];
      _learnq.push(["track", "Added to Cart",{
        $value: $product.price/100,
        "Brand": $product.vendor,
        "ProductName": $product.title,
        "ProductPrice": $product.price/100,
        "ProductID": $product.id,
        "ProductImageURL": $product.featured_image,
        "ProductURL": window.location.origin +"/products/"+$product.handle,
        "PageURL": window.location.href
      }]);
    }
  },
  remove_from_cart: function(product,vid,q){
    if(window.showLog) console.log('======remove_from_cart======');
     dataLayer.push({
      'event': "remove_from_cart",
      'ecommerce': {
        'currencyCode': "AUD",
        'remove':{
          'products':[{
            'name': product.product_title,
            'id': product.product_id,
            'price': product.price/100,
            'brand': product.vendor,
            'variant': product.variant_title,
            'quantity': q
          }]
        }  
      }
    });
  },
  added_or_removed: function(index,qty){
    var product = window.cart.items[index],
        qty = parseInt(qty);
    if(product){
      if(product.quantity < qty){
        var Q = qty - product.quantity;
        dataLayer.push({
          'event': "add_to_cart",
          'ecommerce': {
            'currencyCode':"AUD",
            'add':{
              'products':[{
                'name': product.product_title,
                'id': product.product_id,
                'price': product.price/100,
                'brand': product.vendor,
                'variant': product.variant_title,
                'quantity': Q
              }]
            }
          }
        })
      }else if(product.quantity > qty){
        // removed
        var Q = product.quantity - qty;
        dataLayer.push({
          'event': "remove_from_cart",
          'ecommerce': {
            'currencyCode': "AUD",
            'remove':{
              'products':[{
                'name': product.product_title,
                'id': product.product_id,
                'price': product.price/100,
                'brand': product.vendor,
                'variant': product.variant_title,
                'quantity': Q
              }]
            }  
          }
        })
      }
    }
  },
  view_cart: function(){
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      window.cart = cart;
      if(window.showLog) console.log('======view_cart======');
          var Citems = cart.items;
          var items = [];
          for (i=0; i < Citems.length; i++) {
            var item = {},
              product = Citems[i];
            item.item_id = product.product_id;
            item.item_name = product.product_title;
            item.affiliation = "elitesupps";
            item.currency = "AUD";
            item.index = i;
            item.item_brand = product.vendor;
            item.item_category = 'all';
            item.item_variant = product.variant_title;
            item.price = product.price;
            item.quantity = product.quantity;
            if(product.discounts[0]){
              item.coupon = product.discounts[0].title;
              item.discount = product.discounts[0].amount;
            }
            items.push(item);
          }
          dataLayer.push({
            'event': "view_cart",
            'ecommerce': {
              'currency': "AUD",
              'value': cart.total_price/100,
              'items': items
            }
          })
    });    
  },
  productClick: function(pid,list) {
    if(window.showLog) console.log('======productClick======');
    if(pid && list){
      var pdata = productArray[pid];
      if(pdata){
        dataLayer.push({
          'event': "productClick",
          'ecommerce': {
            'currencyCode': "AUD",
            'click': {
             'actionField':{'list':list},
              'products':[pdata]
            }
          }
        })
      }
    }
  },
  old_bundle_add_to_cart: function(product,quantity){
    if(window.showLog) console.log('======bundle_add_to_cart======');
    if(product){
      dataLayer.push({
      'event': "add_to_cart",
      'ecommerce': {
        'currencyCode': "AUD",
        'add':{
          'products':[{
            'name': product.title,
            'id': product.id,
            'price': product.price/100,
            'brand': product.vendor,
            'variant': product.variants[0].title,
            'quantity': quantity
           }]
         }  
       }
      })
    }
  }
}